import { Box, Card, Grid } from "@mui/material";
import PropTypes from "prop-types";
import SoftBox from "components/SoftComponents/SoftBox";
import SoftButton from "components/SoftComponents/SoftButton";
import { useMatch, useNavigate } from "react-router-dom";
import SoftTypography from "components/SoftComponents/SoftTypography";
import InspectionsFormV3 from "modules/inspections/components/InspectionForm";
import { processDeviceData } from "utils/device";
import bksAPI from "services/api/bks";
import inspectionAPI from "modules/inspections/api";
import { useAuth0 } from "@auth0/auth0-react";
import { useMutation } from "@tanstack/react-query";
import AssignmentForm from "modules/inspections/components/AssignmentForm";

function CreateAssignment({ selected_user, all_devices, inspection_data }) {

    inspectionAPI.loadToken(useAuth0());

    const { mutateAsync } = useMutation({
        mutationFn: (values) => {
            console.log(values)
            return inspectionAPI.addNewRectification(values)
        }
    })

    return <AssignmentForm {...{ selected_user, all_devices}} inspection_record={inspection_data} onSubmit={mutateAsync} />
}

CreateAssignment.propTypes = {
    selected_user: PropTypes.object.isRequired,
    all_devices: PropTypes.array.isRequired,
    inspection_data: PropTypes.object.isRequired
};

export default CreateAssignment;
